export enum Plugin {
  DASHBOARD = "DASHBOARD",
  WEBSITE = "WEBSITE",
  MESSAGING = "MESSAGING",
  SLOTTING = "SLOTTING",
  CHECK_IN = "CHECK_IN",
  SEATING = "SEATING",
  ACTIONS = "ACTIONS",
  ATTACHMENTS = "ATTACHMENTS",
  DOCUMENTS = "DOCUMENTS",
  GOALS = "GOALS",
  ATTENDEE_APP = "ATTENDEE_APP",
  PROGRAM = "PROGRAM",
  SPEAKERS = "SPEAKERS",
  SPONSORS = "SPONSORS",
  /**
   * SMS from automations (SMS plugin wave, 26.10.2026). Never in a template, a
   * copy, the create wizard or a Velo patch: adding it needs an OWNER/ADMIN of
   * the event's company, the platform switch on and a company allowance — the
   * backend refuses it otherwise (`smsPluginNeedsCompanyAdmin`).
   */
  SMS = "SMS",
}

/** Every plugin the create wizard, the directions and the template tab know — all but SMS. */
export type WizardPlugin = Exclude<Plugin, Plugin.SMS>;
